<template>
  <div class="flex flex-col gap-4">
    <div>
      {{ t('canvasUI.components.fileViewer.closeDialog.description') }}
    </div>

    <CCheckbox
      :checked="rememberForNextTime"
      :label="t('canvasUI.components.fileViewer.closeDialog.rememberForNextTime')"
      @update:checked="(val) => emit('update:rememberForNextTime', val)"
    >
    </CCheckbox>
  </div>
</template>

<script lang="ts" setup>
import { useI18n } from 'vue-i18n'
import CCheckbox from '@lib/components/CCheckbox/CCheckbox.vue'

const { t } = useI18n()

defineProps<{
  rememberForNextTime: boolean
}>()

const emit = defineEmits<{
  'update:rememberForNextTime': [value: boolean]
}>()
</script>
